export default "__VITE_ASSET__e862d4a4__"